export type Redirect = (path: string) => void;

export const redirect: Redirect = (path) => {
    window.location.assign(path);
};
